/**
 * @ngdoc directive
 * @name directiveAdvancedSearch
 * @restrict A
 *
 * @description
 * Directive for accordion.
 */
export default function () {
    return {
        restrict: 'A', // Only element name can be used for directive definition
        link: (directiveAccordionCtrl) => {
            directiveAccordionCtrl.init();
        },
        controller: 'directiveAccordionCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/accordion.js